// extracted by css-extract-rspack-plugin
module.exports =  {"source":"Source35-HOy___source"};